import React, { useState, useContext, useEffect, useRef } from 'react'
import { getWellName, ContainerBody, EditingHeader, Footer, __SOURCE_ILT__PLAN_VS_TARGET, getUnixFromDateAndTime, makeHisotry, Comment } from '../commom'
import { DashboardContext } from 'live/context/dashboard'
import Authorization from 'live/services/authorization'
import api from '../../api'

function makeExtra(event, form, wellName) {
    const extra = {
        authorId: Authorization.user.id,
        author: Authorization.user.username,
        wellbore_name: wellName,
        comment: form.comment,
        section_name: event?.section_name,
        activity_name_final_event: event?.activity_name_final_event,
        sub_activity_name_final_event: event?.sub_activity_name_final_event
    }

    return extra
}

export default function (props) {
    const { event, onHide } = props
    const { state, params, ...context } = useContext(DashboardContext)
    const wellName = event?.wellbore_name ?? event?.extra?.wellbore_name ?? getWellName(params.filter)
    const [form, setForm] = useState<any>(event?.extra ?? {})

    function onSubmit() {
        const payload = {
            ...event,
            extra: makeExtra(event, form, wellName),
            uid: (event && event.uid) || undefined,
            __src: __SOURCE_ILT__PLAN_VS_TARGET,
            message: form.manual_iltSubActivity,
            activeDashboardFilters: props.activeDashboardFilters,
        }

        payload['extra']['history'] = makeHisotry(event, payload)

        api.createAnnotation(payload).then(e => {
            onHide()
        })
    }

    return <ContainerBody>
        {props.editing ? <EditingHeader title={"ILT Edition"}/> : null }
        <div className="timeline__form">
            <Comment label="Comment" form={form} setForm={setForm} />
            <br />
            <Footer form={form} onSubmit={onSubmit} disabled={false} onHide={onHide} />
        </div>
    </ContainerBody >
}